/**
 * forms.js
 *
 * @package Wordpress/sww
 * @since 1.0.0
 * @version 1.0.0
 */

if( !window.swwapp.forms ) {

	window.swwapp.forms = {};

	swwapp.forms = window.swwapp.forms;

	if( swwapp.jsdebug == true ) { console.log( 'Forms Object added.' ); }

}

jQuery( function($) {

	$( document ).ready( function() {

		//get the actual forms output container
		swwapp.forms.outputContainer = $( 'div.wpcf7-response-output' );

		//get the forms height
		swwapp.forms.height = function() {

			var height = $( 'section.sww-header > div.header-row' ).height();
			// console.log( 'header ' + $( 'div.sww-header > div.header-row' ).height() );

			height += $( 'section.main' ).height();
			// console.log( 'mainsection ' + $( 'section.main' ).height() );

			height += $( 'form' ).height();
			// console.log( 'formheight ' + $( 'form' ).height() );

			if( swwapp.forms.containerStatus === false ) {

				height = height + $( 'div.wpcf7-validation-errors' ).height();
				// console.log( 'errorcontainer ' + $( 'div.wpcf7-validation-errors' ).height() );

			} else if( swwapp.forms.containerStauts === true ) {

				height = height + $( 'div.wpcf7-mail-sent-ok' ).height();
				// console.log( 'ok-container ' + $( 'div.wpcf7-mail-sent-ok' ).height() );

			}

			return height;

		};

		//get container status
		swwapp.forms.watchContainerStatus = function() {

			var status = 'none';

			if( $( swwapp.forms.outputContainer ).hasClass( 'wpcf7-validation-errors' ) ) {

				status = false;

			} else if( $( swwapp.forms.outputContainer ).hasClass( 'wpcf7-mail-sent-ok' ) ) {

				status = true;

			}

			return status;

		};

		//toggles
		swwapp.forms.toggle = function( e ) {

			var event = e;
			var parentElement = $( event.srcElement.offsetParent );
			var value = event.srcElement.value;

			console.log( event.srcElement.value );

			switch( parentElement[0].classList[1] ) {

				case "kwk-kontostatus":

					if( value === 'nicht bekannt' ) {

						$( 'div.kwk-kontostatus' ).addClass( 'shown' );

					} else {

						$( 'div.kwk-kontostatus' ).removeClass( 'shown' );

					}

				break;

				case "kwk-nk-angebot":

					if( $( 'div.kwk-'+value.toLowerCase() ).hasClass( 'shown' ) === false ) {

						$( 'div.kwk-'+value.toLowerCase() ).addClass( 'shown' );

					} else {

						$( 'div.kwk-'+value.toLowerCase() ).removeClass( 'shown' );

					}

				break;

			}

			return true;

		};

		//pagination
		swwapp.forms.pagination = function( e ) {

			var event = e;

			if( $( event.currentTarget ).hasClass( 'active' ) === true ) {

				console.log( 'already open' );

				return false;

			} else {

				$( '.sww-form-tab.active' ).toggleClass( 'active' );

				$( event.currentTarget ).addClass( 'active' );

				$( '.sww-form-page.shown' ).toggleClass( 'shown' );

				$( '.sww-form-page-'+event.currentTarget.dataset.tab ).addClass( 'shown' );

			}

			console.log( e );

		};

		swwapp.forms.watch = function() {

			swwapp.forms.containerStatus = swwapp.forms.watchContainerStatus();

			switch( swwapp.forms.containerStatus ) {

				case 'none':
				break;

				case true:

					$( 'footer.site-footer' ).css( 'top', swwapp.forms.height() );

				break;

				case false:

					$( 'footer.site-footer' ).css( 'top', swwapp.forms.height() );

				break;



			}

			// console.log( swwapp.forms.containerStatus );

		};

		if( $( 'div.wpcf7-response-output' ).height() ) {

			swwapp.forms.watcher = setInterval( swwapp.forms.watch, 300 );

		}

		//watch radiobuttons and checkboxex on changes
		$( '.sww-form input[type="radio"], sww-form input[type="checkbox"], .wpcf7-form input[type="checkbox"]' ).on( 'change', $( this ), swwapp.forms.toggle );

		//clickHandler form tabs
		$( '.sww-form-tab' ).on( 'click', swwapp.forms.pagination );

	} );

} );
